import { createEnum } from "@redotech/zod-util/zod-enum";

export enum RedoFinderLoadType {
  FULL_PATH = "full_path",
  CHILDREN_ONLY = "children_only",
}
export const RedoFinderLoadTypeSchema = createEnum(RedoFinderLoadType);

const redoFinderLoadTypeByValue: Record<
  `${RedoFinderLoadType}`,
  RedoFinderLoadType
> = {
  full_path: RedoFinderLoadType.FULL_PATH,
  children_only: RedoFinderLoadType.CHILDREN_ONLY,
};

export function toRedoFinderLoadType(
  value: `${RedoFinderLoadType}`,
): RedoFinderLoadType {
  return redoFinderLoadTypeByValue[value];
}
